import axios from 'axios'
import { formatAxiosError } from './apiErrors'
const URL = 'https://rentalios-management-helxajom3a-uc.a.run.app/api'
// const URL = "http://localhost:3000/api"
const apiKey = 'db31a33d-9efb-4112-a246-6e60cbd779a8'

export const getCompleteProperties = async (email, { occupancy = '' }) => {
  try {
    const response = await axios({
      method: 'GET',
      url: `${URL}/properties/complete/${email}`,
      params: {
        key: apiKey,
        occupancy: occupancy
      }
    })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return { error: formatAxiosError(error), data: null }
  }
}
